// Centralized route constants for the app

import Login from "../pages/auth/Login";
import OtpVerification from "../pages/auth/OtpVerification";
import GameSelection from "../pages/others/GameSelection";
import RapHousieWaiting from "../pages/rap_housie/RapHousieWaiting";
import RapHousieLeaderBoard from "../pages/rap_housie/RapHousieLeaderBoard";
import SelectRapHousieGame from "../pages/rap_housie/SelectRapHousieGame";
import RapHousieRoomType from "../pages/rap_housie/RapHousieRoomType";
import RapHousieRoomName from "../pages/rap_housie/RapHousieRoomName";
import RapHousieRoomCodeShareStartGame from "../pages/rap_housie/RapHousieRoomCodeShareStartGame";
import RapHousieJoinAnotherRoom from "../pages/rap_housie/RapHousieJoinAnotherRoom";
import RapHousieGameLive from "../pages/rap_housie/RapHousieGameLive";
import RapFireGameLive from "../pages/rap_fire/RapFireGameLive";
import RapFireWaiting from "../pages/rap_fire/RapFireWaiting";
import RapFireLeaderBoard from "../pages/rap_fire/RapFireLeaderBoard";
import SelectRapFireGame from "../pages/rap_fire/SelectRapFireGame";
import RapFireRoomType from "../pages/rap_fire/RapFireRoomType";
import RapFireRoomCodeShareStartGame from "../pages/rap_fire/RapFireRoomCodeShareStartGame";
import RapFireJoinAnotherRoom from "../pages/rap_fire/RapFireJoinAnotherRoom";
import LeaderboardDesignPreview from "../pages/others/LeaderboardDesignPreview";
import RapFireLeaderboardDesignPreview from "../pages/others/RapFireLeaderboardDesignPreview";
import RapFireGameDesignPreview from "../pages/others/RapFireGameDesignPreview";
import TournamentLeaderboardDesignPreview from "../pages/others/TournamentLeaderboardDesignPreview";
import TournamentLeaderBoard from "../pages/tournament/TournamentLeaderBoard";

export const ROUTE_ENUM = {
  ROOT: {
    routePath: '/',
    title: 'Login',
    prevRoute: null,
    data: null,
    component: <Login />,
  },
  AUTH_LOGIN: {
    routePath: '/login',
    title: 'Login',
    prevRoute: null,
    data: null,
    component: <Login />,
  },
  AUTH_OTP: {
    routePath: '/Verify',
    title: 'Code Verification',
    prevRoute: null,
    data: null,
    component: <OtpVerification />,
  },
  SELECT_GAME: {
    routePath: '/Games',
    title: 'Games',
    prevRoute: null,
    data: null,
    component: <GameSelection />,
  },
  SELECT_RAP_HOUSIE_GAME: {
    routePath: '/RapHousieHome',
    title: 'RapHousie Home',
    prevRoute: null,
    data: null,
    component: <SelectRapHousieGame />,
  },
  RAP_HOUSIE_WAITING: {
    routePath: '/RapHousieLobby',
    title: 'RapHousie Lobby',
    prevRoute: null,
    data: null,
    component: <RapHousieWaiting />,
  },
  RAP_HOUSIE_LEADERBOARD: {
    routePath: '/RapHousieLeaderboard',
    title: 'RapHousie Leaderboard',
    prevRoute: null,
    data: null,
    component: <RapHousieLeaderBoard />,
  },
  RAP_HOUSIE_GAME_LIVE: {
    routePath: '/RapHousieLive',
    title: 'RapHousie Live',
    prevRoute: null,
    data: null,
    component: <RapHousieGameLive />,
  },
  RAP_HOUSIE_ROOM_TYPE: {
    routePath: '/RapHousieSelectRoom',
    title: 'RapHousie Select Room',
    prevRoute: null,
    data: null,
    component: <RapHousieRoomType />,
  },
  RAP_HOUSIE_ROOM_NAME: {
    routePath: '/RapHousieRoomName',
    title: 'RapHousie Room Name',
    prevRoute: null,
    data: null,
    component: <RapHousieRoomName />,
  },
  RAP_HOUSIE_ROOM_CODE_SHARE_START_GAME: {
    routePath: '/RapHousieRoomLobby',
    title: 'RapHousie Room Lobby',
    prevRoute: null,
    data: null,
    component: <RapHousieRoomCodeShareStartGame />,
  },
  RAP_HOUSIE_JOIN_ANOTHER_ROOM: {
    routePath: '/RapHousieJoinRoom',
    title: 'RapHousie Join Room',
    prevRoute: null,
    data: null,
    component: <RapHousieJoinAnotherRoom />,
  },
  SELECT_RAP_FIRE_GAME: {
    routePath: '/RapFireHome',
    title: 'RapFire Home',
    prevRoute: null,
    data: null,
    component: <SelectRapFireGame />,
  },
  RAP_FIRE_ROOM_TYPE: {
    routePath: '/RapFireSelectRoom',
    title: 'RapFire Select Room',
    prevRoute: null,
    data: null,
    component: <RapFireRoomType />,
  },
  RAP_FIRE_ROOM_CODE_SHARE_START_GAME: {
    routePath: '/RapFireRoomLobby',
    title: 'RapFire Room Lobby',
    prevRoute: null,
    data: null,
    component: <RapFireRoomCodeShareStartGame />,
  },
  RAP_FIRE_JOIN_ANOTHER_ROOM: {
    routePath: '/RapFireJoinRoom',
    title: 'RapFire Join Room',
    prevRoute: null,
    data: null,
    component: <RapFireJoinAnotherRoom />,
  },
  RAP_FIRE_GAME: {
    routePath: '/RapFireLive',
    title: 'RapFire Live',
    prevRoute: null,
    data: null,
    component: <RapFireGameLive />,
  },
  RAP_FIRE_WAITING: {
    routePath: '/RapFireLobby',
    title: 'RapFire Lobby',
    prevRoute: null,
    data: null,
    component: <RapFireWaiting />,
  },
  RAP_FIRE_LEADERBOARD: {
    routePath: '/RapFireLeaderboard',
    title: 'RapFire Leaderboard',
    prevRoute: null,
    data: null,
    component: <RapFireLeaderBoard />,
  },
  TOURNAMENT_LEADERBOARD: {
    routePath: '/tournament/:tournamentId/leaderboard',
    title: 'Tournament Leaderboard',
    prevRoute: null,
    data: null,
    component: <TournamentLeaderBoard />,
  },
  /** TEMP — design preview only; remove after review */
  LEADERBOARD_DESIGN_PREVIEW: {
    routePath: '/preview/leaderboard',
    title: 'Leaderboard Design Preview',
    prevRoute: null,
    data: null,
    component: <LeaderboardDesignPreview />,
  },
  /** TEMP — Rap Fire design preview only; remove after review */
  RAP_FIRE_LEADERBOARD_DESIGN_PREVIEW: {
    routePath: '/preview/rapfire-leaderboard',
    title: 'RapFire Leaderboard Design Preview',
    prevRoute: null,
    data: null,
    component: <RapFireLeaderboardDesignPreview />,
  },
  /** TEMP — Rap Fire live game design preview only; remove after review */
  RAP_FIRE_GAME_DESIGN_PREVIEW: {
    routePath: '/preview/rapfire-game',
    title: 'RapFire Game Design Preview',
    prevRoute: null,
    data: null,
    component: <RapFireGameDesignPreview />,
  },
  /** TEMP — tournament design preview only; remove after review */
  TOURNAMENT_LEADERBOARD_DESIGN_PREVIEW: {
    routePath: '/preview/tournament-leaderboard',
    title: 'Tournament Leaderboard Design Preview',
    prevRoute: null,
    data: null,
    component: <TournamentLeaderboardDesignPreview />,
  },
};
